export default __webpack_public_path__ + "static/media/castles.30765c0e.svg";